import React, {Component} from 'react';

import styles from '../../../static/css/layoutStyleModules/footerLayout.module.scss';


import SvgIconBaseComponent from '../../svgIconComponents/SvgIconBaseComponent.js';

export default class MainViewSelecterTab extends Component {
    constructor(props) {
        super(props)
        this.state = {

        } 
    }

    changeViewMode = (targetMode) => {
        this.props.onTabPanelClick(targetMode);
    }

    currentTabColor = (viewModeOfTheTab) => {
        if(this.props.currentViewMode === viewModeOfTheTab){
            return {color:'hsl(6,77%,64%)'};
        }else {
            return {color:'#999999'};
        }
    }

    render() {
        const mainTabPanels = [
            {display:'ありがと',icon:'facedHeart',viewMode:'thanksView'},
            {display:'メンバー',icon:'defaultGuy',viewMode:'memberView'},
            {display:'インフォ',icon:'info',viewMode:'infoView'},
        ]

        return (
            <div className={styles['footerWholeArea']}>
            
              {mainTabPanels.map((panel) => {
                  return(
                      <div className={styles['tabPanel']} key={panel.display}
                      onClick={ () => {this.changeViewMode(panel.viewMode)} }>
                        <div className={styles['panelIcon']}>
                          <SvgIconBaseComponent image={panel.icon} fillColor={this.currentTabColor(panel.viewMode).color}/>
                        </div>
                        <div className={styles['panelDisplay']}
                        style={this.currentTabColor(panel.viewMode)}>{panel.display}</div>
                      </div>
                  )
              })}
            </div>
        )
    }
}

//一応footerと大きく銘打ってあるが、実際はメインのタブ。
//あとでタブバーを増やすなら、これはそのひとつになる。